@reference "./tailwind-ref.css";

.dateInputCalendar {
  @apply !border-0;

  :global(.react-calendar__navigation) {
    @apply mb-2xl h-4xl;
  }

  :global(.react-calendar__navigation__prev-button),
  :global(.react-calendar__navigation__next-button) {
    @apply flex items-center justify-center cursor-pointer border border-solid border-primary rounded-lg !min-w-4xl !w-4xl h-4xl;
  }

  :global(.react-calendar__navigation__prev2-button),
  :global(.react-calendar__navigation__next2-button) {
    @apply hidden;
  }

  :global(.react-calendar__navigation__label) {
    @apply flex items-center justify-around;

    :global(span) {
      @apply font-manrope text-primary text-base font-bold;
    }

    :global(.react-calendar__navigation__label__divider) {
      @apply hidden;
    }
  }

  :global(.react-calendar__viewContainer) {
    @apply m-0 gap-16;
  }

  :global(.react-calendar__month-view) {
    @apply m-0;
  }

  :global(.react-calendar__month-view__weekdays__weekday) {
    @apply mb-2.5;

    :global(abbr) {
      @apply font-manrope text-2xs font-medium text-secondary no-underline uppercase;
    }
  }

  :global(.react-calendar__tile),
  :global(.react-calendar__tile--now) {
    @apply relative h-2xl !p-0 mb-md text-primary font-manrope text-xs font-medium uppercase isolate before:absolute before:top-0 before:left-1/2  before:-z-[1] before:w-full before:h-full before:content-[''] before:bg-transparent before:rounded-lg before:-translate-x-1/2;
  }

  :global(.react-calendar__tile--active) {
    @apply !text-inverse bg-brand-dark;
  }

  :global(.react-calendar__tile--hasActive) {
    @apply text-inverse bg-brand-dark rounded-lg;
  }

  :global(.react-calendar__tile--now) {
    @apply bg-transparent before:bg-brand-lightest text-primary;
  }

  :global(.react-calendar__tile--hover),
  :global(.react-calendar__tile:enabled:hover) {
    @apply inline-block text-inverse !bg-transparent before:bg-brand-dark;
  }

  :global(.react-calendar__tile--rangeStart) {
    @apply relative overflow-hidden !bg-transparent before:absolute before:top-0 before:left-1/2 before:-z-[1] before:content-[''] before:bg-brand-dark before:rounded-lg before:-translate-x-1/2;
  }

  :global(.react-calendar__tile--rangeEnd) {
    @apply relative overflow-hidden !bg-transparent isolate before:absolute before:top-0 before:left-1/2 before:-z-[1] before:content-[''] before:bg-brand-dark before:rounded-lg before:-translate-x-1/2;
  }

  :global(.react-calendar__tile--active:enabled:hover),
  :global(.react-calendar__tile--active:enabled:focus) {
    @apply bg-brand-dark;
  }

  :global(.react-calendar__month-view__days) {
    :global(.react-calendar__tile::before),
    :global(.react-calendar__tile--now::before),
    :global(.react-calendar__tile--rangeEnd::before),
    :global(.react-calendar__tile--rangeStart::before),
    :global(.react-calendar__tile--hover),
    :global(.react-calendar__tile:enabled:hover) {
      @apply w-2xl h-2xl rounded-full;
    }
  }

  :global(button[disabled].react-calendar__tile) {
    @apply cursor-not-allowed bg-transparent opacity-25;
  }
}

.dateRangeCalendar {
  @apply !border-0;

  :global(.react-calendar__navigation) {
    @apply mb-2xl h-4xl;
  }

  :global(.react-calendar__navigation__label__labelText) {
    @apply w-1/2;
  }

  :global(.react-calendar__navigation__label__labelText--from) {
    @apply pr-16;
  }

  :global(.react-calendar__navigation__label__labelText--to) {
    @apply pl-16;
  }

  :global(.react-calendar__navigation__prev-button),
  :global(.react-calendar__navigation__next-button) {
    @apply flex items-center justify-center cursor-pointer border border-solid border-primary rounded-lg !min-w-4xl !w-4xl h-4xl;
  }

  :global(.react-calendar__navigation__prev2-button),
  :global(.react-calendar__navigation__next2-button) {
    @apply hidden;
  }

  :global(.react-calendar__navigation__label) {
    @apply flex items-center justify-around;

    :global(span) {
      @apply font-manrope text-primary text-base font-bold;
    }

    :global(.react-calendar__navigation__label__divider) {
      @apply hidden;
    }
  }

  :global(.react-calendar__viewContainer) {
    @apply m-0 !gap-2xl;
  }

  :global(.react-calendar__month-view) {
    @apply m-0;
  }

  :global(.react-calendar__month-view__weekdays__weekday) {
    @apply mb-2.5;

    :global(abbr) {
      @apply font-manrope text-2xs font-medium text-secondary no-underline uppercase;
    }
  }

  :global(.react-calendar__month-view__days) {
    button {
      &:nth-child(7n + 1) {
        @apply rounded-l-full;
      }

      &:nth-child(7n + 7) {
        @apply rounded-r-full;
      }
    }
  }

  :global(.react-calendar__tile) {
    @apply h-2xl p-0 mb-md text-primary font-manrope text-xs font-medium uppercase bg-brand-lightest;
  }

  :global(.react-calendar__tile--active) {
    @apply text-inverse bg-brand-dark;
  }

  :global(.react-calendar__tile--hover) {
    @apply !text-inverse !bg-brand-dark;
  }

  :global(.react-calendar__tile:enabled:hover) {
    @apply text-inverse !bg-brand-dark;
  }

  :global(.react-calendar__tile--rangeStart) {
    @apply relative overflow-hidden bg-brand-lightest rounded-l-none isolate text-inverse;
  }

  :global(.react-calendar__tile--rangeStart::before) {
    @apply absolute -z-[1] content-[''] bg-brand-dark rounded-l-full inset-0;
  }

  :global(.react-calendar__tile--rangeEnd) {
    @apply relative overflow-hidden bg-brand-lightest rounded-r-none isolate text-inverse;
  }

  :global(.react-calendar__tile--rangeEnd::before) {
    @apply absolute -z-[1] content-[''] bg-brand-dark rounded-r-full inset-0;
  }

  :global(.react-calendar__tile--active:enabled:hover) {
    @apply bg-brand-dark;
  }

  :global(.react-calendar__tile--active:enabled:focus) {
    @apply bg-brand-lightest;
  }
}
